/**
 * Helper: CSS classes
 * -----------------------------------------------------------------------------
 * Global configuration for css classes.
 * - Used to provide consistency and keep DRY for our toggle classes.
 */
export default {
  active: 'is-active',
  added: 'is-added',
  collapsed: 'is-collapsed',
  disabled: 'is-disabled',
  enabled: 'is-enabled',
  expanded: 'is-expanded',
  error: 'is-error',
  fadeIn: 'fade-in',
  fadeOut: 'fade-out',
  hidden: 'is-hidden',
  lazyload: 'lazyload',
  lazyloaded: 'lazyloaded',
  loading: 'is-loading',
  locked: 'is-locked',
  pagination: 'has-pagination',
  muted: 'is-muted',
  removing: 'is-removing',
  paused: 'is-paused',
  playing: 'is-playing',
  scrollDown: 'scroll-down',
  scrollUp: 'scroll-up',
  sticky: 'is-sticky',
  tabbable: 'is-tabbable',
  tier2: 'tier-2-open',
  tier2Closing: 'tier-2-closing',
  visible: 'is-visible'
};